<template>
  <div _bg="[#FFFFFF]" class="content" _p="x-20px" _m="y-20px" ref="scrollContainer">
    <div _bg="[#F6F6F6]" _text="[#505050] 18px bold" class="text-center" _w="88px" _h="34px" _m="b-20px" _border="rounded-[4px]">版本动态</div>
    <div _w="100%" _h="1px" _bg="[#D9D9D9]" _m="b-22px"></div>
    <div _flex="~" _m="b-3px" _pos="relative" v-for="(item, index) in list" :key="index">
      <img :src="require('@/assets/image/version.png')" width="24px" height="24px" _m="r-12px"/>
      <img :src="item?.account?.avatar?.url || require('@/assets/image/headshot.png')" _border="rounded-[1200px]" width="42px" height="42px" _m="r-12px t-6px"/>
      <div _m="t-13px b-24px" _w="500px" :class="[ list.length -1 != index && 'has-xian']">
        <span _text="[#9D9D9D] 16px" _h="28px" _m="r-12px">{{ item?.account?.realname }}</span>
        <span _text="[#9D9D9D] 16px">{{ item.updated_at }}</span>
        <div style="min-height:34px;line-height:1.5" _bg="[#F6F6F6]" _text="[#505050] 14px bold" class="text-center min-width-88" _m="t-9px" _border="rounded-[4px]">{{ item.action }}</div>
      </div>
    </div>
    <div _w="100%" _text="center" v-if="loading">加载中</div>
    <div _w="100%" _text="center" v-if="!hasMore">没有更多了~</div>
  </div>
</template>

<script>
export default {
  name: 'version',
  props: {
    id: Number,
    visible: Boolean
  },
  data() {
    return {
      list: [],
      meta: {
        page: 1,
        page_size: 10
      },
      loading: false, // 👈 新增加载状态
      hasMore: true   // 👈 是否还有更多数据
    }
  },
  methods: {
    handleScroll() {
      if (this.loading || !this.hasMore) return;
      const container = this.$refs.scrollContainer;
      const distanceToBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
      // 提前一点触发（比如 50px 内）
      if (distanceToBottom <= 50 && this.visible) {
        this.loadMore();
      }
    },
    async loadMore() {
      if (this.loading || !this.hasMore) return;
      this.loading = true;
      try {
        this.meta.page += 1;
        const { data, meta } = await this.$api.user.httpGet('textbook-course-history/' + this.id, this.meta);
        if (data && data.length > 0) {
          this.list = [...this.list, ...data];
          this.meta.page = meta.current_page;
          this.hasMore = meta.current_page < meta.last_page;
        } else {
          this.hasMore = false;
        }
      } catch (error) {
        console.error('加载历史记录失败:', error);
        this.meta.page -= 1; // 回滚页码
      } finally {
        this.loading = false;
      }
    },

    async getHistory() {
      // 重置状态
      this.loading = true;
      this.list = [];
      this.meta.page = 1;
      this.hasMore = true;

      try {
        const { data, meta } = await this.$api.user.httpGet('textbook-course-history/' + this.id, this.meta);
        this.list = data || [];
        this.meta.page = meta.current_page;
        this.hasMore = meta.current_page < meta.last_page;
      } catch (error) {
        this.list = [];
        this.hasMore = false;
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.getHistory();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$refs.scrollContainer?.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    this.$refs.scrollContainer?.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style lang="scss" scoped>
.content {
	height: 450px;
  overflow-y: auto;
}
.text-center {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
}
.min-width-88 {
  width: fit-content;
  min-width: 88px;
}
.has-xian::before {
  content: "";
  position: absolute;
  left: 11px;
  top: 24px;
  height: -webkit-fill-available;
  border-radius: 11px 11px 11px 11px;
  border: 1px dashed #CECECE;
}
</style>
